import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from "vuetify/lib";
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);


export default new Vuetify({
    theme: {
        theme: {
            primary: "#4792CF",
            secondary: "#29B6F6",
            accent: "#26C6DA",
            error: "#f44336",
            warning: "#FF8F00",
            info: "#2196f3",
            success: "#4caf50"
        },
    },
    icons: {
        iconfont: 'mdi',
    },
});
